import { Box, Stack } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { SettingsSwitch } from '@repo/common/components';
import { Title } from '@repo/foundations';
import { useState } from 'react';
import type { IIntegration } from '../../../../../api';
import { useUpdateIntegration } from '../../../../../api';

interface UserLevelCredentialsProps {
	integration: IIntegration;
}

export function UserLevelCredentials({
	integration,
}: UserLevelCredentialsProps) {
	const [isLoading, setIsLoading] = useState(false);
	const { mutateAsync: updateIntegration } = useUpdateIntegration({});

	const handleToggle = async (checked: boolean) => {
		setIsLoading(true);
		try {
			await updateIntegration({
				data: {
					id: integration.id,
					query_execute_use_user_level_credentials: checked,
				},
			});
			showNotification({
				title: 'Success',
				message: 'User level credentials setting updated successfully',
				color: 'green',
			});
		} catch (error) {
			showNotification({
				title: 'Error',
				message: 'Failed to update user level credentials setting',
				color: 'red',
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Stack spacing="md">
			<Title size="md">User level credentials</Title>
			<Box>
				<SettingsSwitch
					title="Require user credentials for querying"
					description="When enabled, all users will be required to input their own credentials for this integration when executing queries"
					checked={
						integration.query_execute_use_user_level_credentials ?? false
					}
					onChange={handleToggle}
					disabled={isLoading}
				/>
			</Box>
		</Stack>
	);
}
